<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="承办单位" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.printStatus" placeholder="打印状态" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.evaluateStatus3)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-date-picker v-model="publishTime" type="daterange" range-separator="至" start-placeholder="发布开始日期" end-placeholder="发布结束日期"
                        value-format="yyyy-MM-ddTHH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList()" type="default">重置</el-button>
        <KtButton @click="$router.push({path:'./printing'})" label="打印" type="primary" perms='evaluation-certificate-export'></KtButton>
        <!--        <el-button @click="publish()" type="primary">生成证书</el-button>-->
        <!--        <el-button type="primary">批量打印</el-button>-->
      </div>
      <!--      <div class="text-right" style="margin-top: 10px;">-->
      <!--        <el-button type="primary" style="margin-right: 0px;">-->
      <!--          发布-->
      <!--        </el-button>-->
      <!--      </div>-->
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="examineeName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span class="text-click pointer"
                    @click="$router.push({path:'./performance-edit',query:{batchId:scope.row.batchId,specialtyId:scope.row.specialtyId,evaluateExamId:scope.row.evaluateExamId}})">
                    {{scope.row.examineeName}}
              </span>
              <i v-if="scope.row.examineeName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span class="text-click pointer"
                    @click="$router.push({path:'./performance-edit',query:{batchId:scope.row.batchId,specialtyId:scope.row.specialtyId,evaluateExamId:scope.row.evaluateExamId}})">
                    {{scope.row.examineeName2}}
              </span>
              <i v-if="scope.row.examineeName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别"></el-table-column>
        <el-table-column prop="country" label="国籍"></el-table-column>
        <el-table-column prop="nationality" label="民族"></el-table-column>
        <el-table-column prop="birthday" label="出生日期"></el-table-column>
        <el-table-column prop="specialtyName" label="考级专业"></el-table-column>
        <el-table-column prop="gradeName" label="级别"></el-table-column>
        <el-table-column prop="publishTime" label="成绩发布时间"></el-table-column>
        <el-table-column prop="makeCertificateTime" label="发证时间"></el-table-column>
        <el-table-column prop="gradeStartEnd" label="起止级"></el-table-column>
        <el-table-column prop="evaluateCertificateNo" label="证书编号"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200, 300]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import KtButton from '../../components/ktButton'

export default {
  name: 'list',
  components: { KtButton },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      agentList: [],
      pageList: [],
      publishTime: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
      this.$store.commit('setMultipleSelection', this.multipleSelection)
      const evaluateExamIds = this.multipleSelection.map(item => item.evaluateExamId)
      console.log('newList', evaluateExamIds)
    },
    async getPage (queryParam) {
      try {
        this.queryParam.publishStartTime = ''
        this.queryParam.publishEndTime = ''
        this.editForm.show = false
        this.editForm.row = null
        if (this.publishTime) {
          this.$set(this.queryParam, 'publishStartTime', this.publishTime[0])
          this.$set(this.queryParam, 'publishEndTime', this.publishTime[1])
        }
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.printStatus || newQueryParam.printStatus == 0) {
          newQueryParam.printStatus = [newQueryParam.printStatus]
        }
        if (queryParam && !queryParam.pageSize) {
          this.$set(queryParam, 'pageSize', this.page.pageSize)
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.GradeExam.getPageEvaluateCertificate(newQueryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'trueEye2', true)
            if (el.examineeName) {
              el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            }
          })
        }
        this.page = page
        this.pageList = page.list
        console.log(this.page)
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
    // async publish (queryParam) {
    //   if (!this.multipleSelection.length) {
    //     throw new Error('请选择要操作的记录')
    //   }
    //   let confirm = await this.$confirm('确定要生成该证书吗？', '提示', { type: 'warning' })
    //   if (confirm === 'confirm') {
    //     let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
    //     if (newQueryParam.printStatus || newQueryParam.printStatus == 0) {
    //       newQueryParam.printStatus = [newQueryParam.printStatus]
    //     }
    //     newQueryParam = Object.assign({}, newQueryParam, queryParam)
    //     await this.$HTTP.GradeExam.getCertificate(newQueryParam)
    //     this.getTaskInfo('generate_certificate')
    //     // this.$message({ type: 'success', message: '发布成功' })
    //     // await this.getPage()
    //   }
    // },
    // getTaskInfo (taskName) {
    //   // debugger
    //   this.taskInterval = setInterval(async () => {
    //     try {
    //       let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
    //       if (taskInfo) {
    //         if (taskInfo.errorExcelUrl) {
    //           clearInterval(this.taskInterval)
    //           let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
    //           this.Tool.downloadFile(fileUrl)
    //           await this.getPage()
    //         } else if (taskInfo.successExcelUrl) {
    //           clearInterval(this.taskInterval)
    //           let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
    //           this.Tool.downloadFile(fileUrl)
    //           await this.getPage()
    //         } else if (taskInfo.percent >= 100) {
    //           clearInterval(this.taskInterval)
    //           this.$message({ type: 'success', message: '操作成功' })
    //           await this.getPage()
    //         } else if (taskInfo.status >= 2) {
    //           clearInterval(this.taskInterval)
    //           if (taskInfo.errMsg) {
    //             this.$message({ type: 'error', message: taskInfo.errMsg })
    //           }
    //           await this.getPage()
    //         }
    //       } else {
    //         clearInterval(this.taskInterval)
    //       }
    //     } catch (e) {
    //       clearInterval(this.taskInterval)
    //     }
    //   }, 2000)
    // },
    // PrintRow (index, row) {
    //   this.$print(this.$refs.page) // 使用
    // }
  }
}
</script>
